import React from 'react';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen py-24">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-white/90">
          <h1 className="text-3xl font-bold text-white mb-8">Política de Privacidade</h1>
          
          <div className="space-y-6">
            <p className="mb-8">
              Na Kontty, valorizamos a sua privacidade e temos o compromisso de proteger as suas informações pessoais. 
              Esta Política de Privacidade descreve como coletamos, usamos e protegemos suas informações quando você usa nossos serviços.
            </p>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">1. Informações que coletamos</h2>
              <p>Podemos coletar os seguintes tipos de informações:</p>
              <ul className="list-disc ml-6 mt-2 space-y-2">
                <li>Informações pessoais: incluem seu nome, endereço de e-mail, número de telefone e qualquer outra informação que você fornecer ao criar uma conta ou entrar em contato conosco.</li>
                <li>Dados de uso: Podemos coletar informações sobre como você acessa e usa nossos serviços, incluindo seu endereço IP, tipo de navegador e informações do dispositivo.</li>
                <li>Cookies: utilizamos cookies e tecnologias de rastreamento semelhantes para melhorar sua experiência e coletar informações sobre como nossos serviços são usados.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">2. Como usamos suas informações</h2>
              <p>Podemos usar suas informações para os seguintes fins:</p>
              <ul className="list-disc ml-6 mt-2 space-y-2">
                <li>Para fornecer nossos serviços: Usamos suas informações pessoais para criar e gerenciar sua conta, fornecer suporte ao cliente e processar transações.</li>
                <li>Para melhorar nossos serviços: Analisamos dados de uso para entender como nossos serviços são usados e para melhorar nossas ofertas.</li>
                <li>Para nos comunicarmos com você: Podemos enviar atualizações, boletins informativos e materiais promocionais. Você pode cancelar essas comunicações a qualquer momento.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">3. Compartilhamento e divulgação de dados</h2>
              <p>Não vendemos ou alugamos suas informações pessoais a terceiros. Podemos compartilhar suas informações nas seguintes circunstâncias:</p>
              <ul className="list-disc ml-6 mt-2 space-y-2">
                <li>Com prestadores de serviços: podemos contratar prestadores de serviços terceirizados para auxiliar em nossas operações, como processamento de pagamentos e comunicações por e-mail. Estes fornecedores têm acesso às suas informações apenas para desempenhar as suas funções e são obrigados a protegê-las.</li>
                <li>Requisitos legais: Poderemos divulgar suas informações se exigido por lei ou em resposta a solicitações válidas de autoridades públicas.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">4. Segurança de dados</h2>
              <p>Tomamos medidas razoáveis para proteger suas informações pessoais contra acesso, uso ou divulgação não autorizada. No entanto, nenhum método de transmissão pela Internet ou armazenamento eletrônico é 100% seguro e não podemos garantir a sua segurança absoluta.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">5. Seus direitos</h2>
              <p>Você tem o direito de:</p>
              <ul className="list-disc ml-6 mt-2 space-y-2">
                <li>Acessar as informações pessoais que mantemos sobre você</li>
                <li>Solicitar correções em suas informações pessoais</li>
                <li>Solicitar a exclusão de suas informações pessoais, sujeito a certas exceções</li>
                <li>Desativar comunicações de marketing</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">6. Alterações nesta Política de Privacidade</h2>
              <p>Poderemos atualizar esta Política de Privacidade de tempos em tempos. Iremos notificá-lo sobre quaisquer alterações publicando a nova política em nosso site. O uso continuado de nossos serviços após quaisquer alterações constitui sua aceitação da política revisada.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">7. Contate-nos</h2>
              <p>Se você tiver alguma dúvida sobre esta Política de Privacidade ou nossas práticas de dados, entre em contato conosco pelo e-mail team.novacontent@gmail.com.</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}